// @flow
import SearchBar, {
  type SearchBarFilter,
  type SearchBarFilterSuggestion,
  type SearchBarProps,
} from './SearchBar';

export default SearchBar;
export type { SearchBarFilter, SearchBarFilterSuggestion, SearchBarProps };
